import { ArrowDownRight, ArrowUpRight } from "react-feather";
import { Badges, H5, LI, UL } from "../../../../../AbstractElements";
import { BalanceIconWrapData } from "../../../../../Data/UiKits/Modal";

const BalanceIconWrap=()=> {
  return (
    <UL className="simple-list flex-row">
      {BalanceIconWrapData.map((item) => (
        <LI key={item.id}>
          <div className={`balance-item ${item.color}`}>
            <div className="balance-icon-wrap">
              <div className="balance-icon">{item.id === 1 ? <ArrowDownRight /> : <ArrowUpRight />}</div>
            </div>
            <div>
              <span className="f-12 f-light">{item.text} </span>
              <H5>{item.rate}{"K"}</H5>
              <Badges color={`light-${item.color}`} pill className={`text-${item.color}`}>{item.badge}{"%"}</Badges>
            </div>
          </div>
        </LI>
      ))}
    </UL>
  );
}
export default BalanceIconWrap